import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import ProfileCard from '../components/ProfileCard';
import api from '../api/axios';

export default function ShortlistPage() {
  const [profiles, setProfiles] = useState([]);
  const [loading,  setLoading]  = useState(true);

  const load = async () => {
    try {
      const { data } = await api.get('/shortlists');
      setProfiles(data.shortlists || []);
    } catch (err) { console.error(err); }
    finally { setLoading(false); }
  };

  useEffect(() => { load(); }, []);

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      <div className="max-w-7xl mx-auto px-4 py-8">
        <h1 className="font-heading text-2xl font-bold text-gray-900 mb-6">⭐ Shortlisted Profiles</h1>

        {loading ? (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {[...Array(3)].map((_, i) => (
              <div key={i} className="card animate-pulse">
                <div className="h-52 bg-gray-200" />
                <div className="p-4 space-y-2">
                  <div className="h-4 bg-gray-200 rounded w-3/4" />
                  <div className="h-3 bg-gray-200 rounded w-1/2" />
                </div>
              </div>
            ))}
          </div>
        ) : profiles.length === 0 ? (
          <div className="text-center py-20">
            <p className="text-5xl mb-4">⭐</p>
            <p className="text-gray-500 mb-4">No shortlisted profiles yet.</p>
            <Link to="/search" className="btn-primary inline-block">Browse & Shortlist Profiles</Link>
          </div>
        ) : (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
            {profiles.map(p => (
              <ProfileCard key={p.id} profile={p} onShortlistChange={load} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
